<template>
  <Toast />

  <DataTable
    ref="dv"
    responsiveLayout="scroll"
    id="id_bitacora"
    dataKey="id_bitacora"
    :value="tiposviaje"
    :paginator="true"
    :rows="25"
    :loading="loading1"
    :filters="filters"
    showGridlines
    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
    :rowsPerPageOptions="[25, 50, 75, 100, 125]"
    currentPageReportTemplate="Viendo {first} a {last} de {totalRecords} Tipos de Viaje"
  >
    <Toolbar class="p-mb-4"
      ><template v-slot:right>
        <Button
          label="Nuevo"
          icon="pi pi-plus"
          @click="registroNuevo"
          class="p-button-success p-mr-2"
        /> </template
    ></Toolbar>
    <template #empty><b>No se encontró ningún tipo de viaje.</b></template>
    <template #loading> Cargando Tipos de Viajes... </template>
    <Column
      field="codigo"
      header="Código"
      :sortable="true"
      :autoWidth="true"
    ></Column>
    <Column
      field="descripcion"
      header="Descripción"
      :sortable="true"
      :autoWidth="true"
      style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
    ></Column>
    <Column :exportable="false" style="min-width: 8rem">
      <template #body="slotProps">
        <Button
          icon="pi pi-trash"
          class="p-button-rounded p-button-warning"
          @click="confirmDeleteTipoViaje(slotProps.data)"
        />
      </template>
    </Column>
  </DataTable>
  <Dialog
    v-model:visible="deleteProductDialog"
    :style="{ width: '450px' }"
    header="Confirmacion"
    :modal="true"
  >
    <div class="confirmation-content">
      <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
      <span v-if="product"
        >Esta seguro que desea eliminar el Tipo de Viaje
        <b>{{ product.descripcion }}</b
        >?</span
      >
    </div>
    <template #footer>
      <Button
        label="No"
        icon="pi pi-times"
        class="p-button-text"
        @click="deleteProductDialog = false"
      />
      <Button
        label="Si"
        icon="pi pi-check"
        class="p-button-text"
        @click="deleteProduct"
      />
    </template>
  </Dialog>
</template>
<script>
import { FilterMatchMode } from 'primevue/api';
export default {
  data() {
    return {
      filters: null,
      loading1: true,
      isLoading: false,
      tiposviaje: null,
      deleteProductDialog: false,
    };
  },
  created() {
    this.initFilters();
    this.loadTipoViaje();
  },

  methods: {
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    async loadTipoViaje() {
      try {
        this.tiposviaje = await this.$store.dispatch('loadTiposViaje');
        console.log(this.tiposviaje);
        this.loading1 = false;
      } catch (error) {
        this.error = error.message || 'algo salió mal';
        this.loading1 = false;
      }
    },
    confirmDeleteTipoViaje(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    async deleteProduct() {
      ////console.log(this.product.cusname);
      ////console.log(this.product.cusnit);
      this.deleteProductDialog = false;

      const formData = {
        codigo: this.product.codigo,
        descripcion: this.product.descripcion,
      };
      const response = await this.$store.dispatch('deleteTiposViaje', formData);
      console.log(response);
      console.log(response[0]);
      if (response[0].codigo == 1) {
        this.$toast.add({
          severity: 'success',
          summary: 'Eliminacion ',
          detail: response[0].mensaje,
          //group: 'br',
          life: 2000,
        });
      } else {
        this.$toast.add({
          severity: 'error',
          summary: 'Eliminacion',
          detail: response[0].mensaje,
          //group: 'br',
          life: 2000,
        });
      }
      this.loadTipoViaje();
    },
    registroNuevo() {
      const redirectUrl =
        '/' + (this.$route.query.redirect || 'insert/tiposviaje');
      this.$router.replace(redirectUrl);
    },
  },
};
</script>
